// src/utils/helpers.js
export const generateSignHashUrl = (
  baseUrl,
  axrWalletAddress,
  network,
  generatedHash
) => {
  const params = new URLSearchParams({
    axrWalletAddress,
    network,
    generatedHash,
  });
  return `${baseUrl}/sign-hash?${params.toString()}`;
};

export const parseSignHashUrl = (url) => {
  const params = new URLSearchParams(url.split("?")[1]);
  return {
    axrWalletAddress: params.get("axrWalletAddress"),
    network: params.get("network"),
    generatedHash: params.get("generatedHash"),
  };
};
